import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

import { USER_ROLES } from 'utils/role-utils';
import RoleGuard from 'utils/route-guard/RoleGuard';

export default function CustomerLayout() {
  return (
    <RoleGuard allowedRoles={[USER_ROLES.CUSTOMER]}>
      <Box>
        <Outlet />
      </Box>
    </RoleGuard>
  );
}
